// NPM imports
import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@revvsales/components";

// Components Imports

// Actions Imports

// Internal Imports
import { GlobalUtils } from "../../../../utils";
import { ASSET } from "../../../../constants";

// Destructuring
const { ASSET_PAGE_URL } = ASSET;
const { truncateString } = GlobalUtils;

const AssetHeaderBreadcrumb = props => {
  const { assetBreadcrumbData, currentFolderID, className } = props;
  const _getAssetFolderUrl = data => {
    let url = null;
    if (data.id === null) {
      url = `/${ASSET_PAGE_URL}`;
    } else {
      url = `/${ASSET_PAGE_URL}/${data.name
        .toLocaleLowerCase()
        .split(" ")
        .join("-")}/${data.id}`;
      if (data.opportunity_root && data.opportunity_id) {
        url = `${url}?opp_id=${data.opportunity_id}`;
      }
    }
    return encodeURI(encodeURI(url));
  };

  const _getBreadCrumbDetails = breadCrumb => {
    let breadCru = "";
    if (
      assetBreadcrumbData.length === 1 &&
      assetBreadcrumbData[assetBreadcrumbData.length - 1].name === "All"
    ) {
      breadCru = "All documents and folders";
    } else if (currentFolderID === breadCrumb.id) {
      breadCru = breadCrumb.name;
    } else {
      breadCru =
        breadCrumb.name !== "All" ? (
          <Tooltip
            placement="bottom"
            overlay={breadCrumb.name}
            align={{
              offset: [0, 4],
            }}>
            <span>{truncateString(breadCrumb.name, 3, true, 2)}</span>
          </Tooltip>
        ) : (
          breadCrumb.name
        );
    }
    return breadCru;
  };

  return (
    <div className="assetheaderbreadcrumb-container ">
      {assetBreadcrumbData.map((bc, index) => (
        <div
          className={`assetheaderbreadcrumb-bredcrumb-item ${className}`}
          key={bc.id}>
          <Link
            to={_getAssetFolderUrl(bc)}
            onClick={() => {
              // Reset only when user clicks the "All" hyperlink
              if (index === 0) {
                props.resetAssetDocumentView();
              }
            }}>
            <span
              className={`assetheaderbreadcrumb-bredcrumb-text ${
                currentFolderID === bc.id ? "active-bredcrumb" : ""
              }`}>
              {_getBreadCrumbDetails(bc)}
              {/* {assetBreadcrumbData[assetBreadcrumbData.length - 1].name ===
              "All"
                ? "All documents and folders"
                : bc.name} */}
              {/* {bc.name} */}
            </span>
          </Link>
          {index < assetBreadcrumbData.length - 1 && (
            <FontAwesomeIcon
              icon={["far", "angle-right"]}
              className="assetheaderbreadcrumb-bredcrumb-icon"
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default AssetHeaderBreadcrumb;



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetHeader/AssetHeaderBreadcrumb/index.js